@if (groupRows) {
  <div class="group-results">
    @for (row of groupRows; track $index) {
      <app-ir-process-history-result [entry]="row" />
    }
  </div>
} @else {
  @switch (type) {
    @case ('BackofficeStatus') {
      @if (oldValues) {
        <p>{{ 'pages.viewInfoRequest.processHistory.changedFrom' | translate }} "{{ oldValues! | translate }}" {{ 'pages.viewInfoRequest.processHistory.changedTo' | translate }} "{{ newValues! | translate }}"</p>
      } @else {
        <p>{{ 'pages.viewInfoRequest.processHistory.setTo' | translate }} "{{ newValues! | translate }}"</p>
      }
    }
    @case ('ResponsibleUser') {
      @if (oldValues) {
        <p>"{{ oldValues }}" {{ 'pages.viewInfoRequest.processHistory.changedTo' | translate }} "{{ newValues }}"</p>
      } @else {
        <p>{{ 'pages.viewInfoRequest.processHistory.setTo' | translate }} "{{ newValues }}"</p>
      }
    }
    @case ('FirstSubmittedVersion') {
      <a class="file-link" (click)="downloadInitialPdf()">
        <i class="bi bi-file-earmark-pdf"></i>
        Sākotnējā pieprasījuma versija
      </a>
    }
    @case ('ProcessingNotes') {
      <p>{{ getProcessingNotesText() }}</p>
    }
    @case ('PaymentNote') {
      <p>{{ getProcessingNotesText() }}</p>
    }
    @case ('CompletionOrCancellationNote') {
      <p>{{ getProcessingNotesText() }}</p>
    }
    @case ('Communication') {
      <p>{{ getCommunicationText() }}</p>
    }
    <!-- LNA-2061: the backend already writes the whole sentence (which message, and when the
         client sent it), so print it verbatim rather than through the generic TERM_MAP path,
         which would rewrite words inside the client's own text. -->
    @case ('CommunicationRead') {
      <p>{{ newValues }}</p>
    }
    @case ('PaymentTypes') {
      <p>{{ getPaymentTypesText() }}</p>
    }
    @case ('PaymentRecorded') {
      <p>{{ getPaymentDateText() }}</p>
    }
    @case ('DocumentDescriptionEdited') {
      <p>{{ getDescriptionEditText() }}</p>
    }
    @default {
      @if (isFileType) {
        @if (isFileDeleted) {
          <p>{{ deletedFileName }}</p>
        } @else {
          <app-file-upload
            [associatedEntityId]="fileOuterId"
            [isEditMode]="false"
            [noPadding]="true"
            [showDescription]="false"
            [type]="fileObjectType"
            [existingFiles]="fileExisting"
          />
        }
        @if (fileNoteText) {
          <p class="file-note">{{ fileNoteText }}</p>
        }
      } @else if (hasGenericContent) {
        <p>{{ getGenericText() }}</p>
      } @else {
        <button class="secondary" (click)="show()">JSON</button>
        <ng-template #content let-c="close" let-d="dismiss">
          <div class="lna-modal-header">
            <h4 class="modal-title">Vērtības</h4>
            <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
          </div>
          <div class="lna-modal-body">
            <pre>{{ entryJson }}</pre>
          </div>
        </ng-template>
      }
    }
  }
}
